import { useEffect, useState } from "react";
import "./checkbox.css";
import { CheckBoxInterface } from "./checkbox.interface";

const CheckBox = ({ label, onChange, defaultValue = false, className = "", containerClassName }: CheckBoxInterface) => {
    const [isChecked, setIsChecked] = useState<boolean>(defaultValue);

    useEffect(() => {
        setIsChecked(defaultValue);
    }, [defaultValue]);

    const handleChangeCheckbox = (event: any) => {
        setIsChecked(event.target.checked);
        onChange(event.target.checked);
    };

    return (
        <label className={`container-checkbox ${containerClassName}`}>
            {!!label && <span className={`text-[14px] font-normal mr-8 ${className}`}>{label}</span>}
            <input
                type="checkbox"
                checked={isChecked}
                onChange={handleChangeCheckbox}
                className="w-4 h-4 text-primary-600 bg-gray-100 !rounded-[6px] border-gray-300 dark:focus:ring-[#2991FF] dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600"
            />
            <span className="checkmark"></span>
        </label>
    );
};

export default CheckBox;
